export default "__VITE_ASSET__BrUO3_Rj__"